import { deleteNode } from "@/input/utils/editOperators";
import { convertParametersToGroup } from "@/input/utils/groupUngroup";

import type { NodeModel } from "@/models/nodes/types";

export function deleteInlineEditableNode(node: NodeModel) {
  const { doc } = node;

  if (!node.isInlineEditable()) {
    return false;
  }

  switch (node.type) {
    case "number": {
      deleteNode(node);
      return true;
    }

    case "function": {
      if (node.paramsAreEmpty) {
        deleteNode(node);
        return true;
      }

      if (node.omitParentheses) {
        const flattened = node.parameters.reduce<NodeModel[]>((acc, n) => [...acc, ...n.nodes], []);

        flattened.forEach((n) => node.insertSiblingBefore(n));
        deleteNode(node);
      } else {
        const groupNode = convertParametersToGroup(node);

        node.replaceWith(groupNode);
        doc.cursor.moveBeforeNode(groupNode);
      }

      return true;
    }

    default: {
      return false;
    }
  }
}
